import { FormControl, FormGroup } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { isAfter, parseISO } from 'date-fns';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { CkNormeValues } from '../common/models/amm-controllo.type';
import { checkDataFutura, validaCodiceFiscale } from '../common/helpers/norme-validators.helper';
import { formPaths } from '@shared/constants/form-paths.const';

export const ruleGuard = (form: FormGroup, ckNormeTargetValue: string, enableValues: CkNormeValues[], ruleFn: () => void) => {
    const my_CkNorme: string = getControl(form, `${formPaths.ammControllo}.my_CkNorme`).value;
    if (!enableValues?.length || (enableValues?.find((e) => e === ckNormeTargetValue) && my_CkNorme === ckNormeTargetValue)) {
        ruleFn();
    }
};

export const checkCkNorme = (form: FormGroup, ckValue: CkNormeValues) => {
    const my_CkNorme: string = getControl(form, `${formPaths.ammControllo}.my_CkNorme`).value;
    return my_CkNorme === ckValue;
};

export const futureOrInconsistentDate = (form: FormGroup, dateControl: FormControl, errorKey: string, ckNormeTargetValue: CkNormeValues) => {
    const my_DataCompilazione: string = getControl(form, `${formPaths.conclusioni}.my_DataCompilaz`)?.value;
    const targetDate = dateControl.value;
    const dataCompilazione = new Date(my_DataCompilazione);
    const resultLater = isAfter(parseISO(targetDate), dataCompilazione);
    const errors = dateControl.errors ? dateControl.errors : {};

    addRemoveError(checkDataFutura(targetDate) && checkCkNorme(form, ckNormeTargetValue), errors, errorKey, {
        status: 'Non è consentita una data futura',
    });

    addRemoveError(resultLater && !isNilOrEmpty(my_DataCompilazione) && checkCkNorme(form, ckNormeTargetValue), errors, errorKey, {
        status: 'Data incoerente con la fine della revisione',
    });

    dateControl.setErrors(isEqual(errors, {}) ? null : errors);
};

export const codiceFiscaleHelper = (group: FormGroup, nomePath: string, cognomePath: string, codiceFiscalePath: string) => {
    const nomeUtenteControl = getControl(group, nomePath);
    const cognomeUtenteControl = getControl(group, cognomePath);
    const codiceFiscaleControl = getControl(group, codiceFiscalePath);

    validaCodiceFiscale(nomeUtenteControl.value, cognomeUtenteControl.value, codiceFiscaleControl);
};
